// @flow
import React, { Component } from 'react';
import { DeviceHeaderDiv, LogoImg, MenuIconDiv } from './DeviceHeaderStyles';
import PageTitle from '../PageTitle';
import netcents from '../../../assets/images/logo-netcents.png';
import netcentsLogomark from '../../../assets/images/nc.png';
import { Mobile, Tablet } from '../../../components/Responsive';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  toggleSidebarDevice: () => void
};

export default class DeviceHeader extends Component<Props> {
  render() {
    return (
      <DeviceHeaderDiv>
        <Mobile>
          <LogoImg src={netcentsLogomark} />
        </Mobile>
        <Tablet>
          <LogoImg src={netcents} />
        </Tablet>
        <PageTitle />
        <MenuIconDiv onClick={this.props.toggleSidebarDevice}>
          <DefaultIcon name="menu" />
        </MenuIconDiv>
      </DeviceHeaderDiv>
    );
  }
}
